// Mirrored with backend schedule-day-order; dates are chronological position slots.
export const orderedDays = days => [...days].sort((a, b) => a.dayNumber - b.dayNumber);
export const dateSlots = days => orderedDays(days).map(d => ({ date: d.date ?? null, rescheduled: Boolean(d.rescheduled) }))
  .sort((a, b) => a.date === b.date ? 0 : a.date == null ? 1 : b.date == null ? -1 : a.date.localeCompare(b.date));
export const validateOrder = (days, order) => {
  const ids = new Set(days.map(d => d.dayNumber));
  return Array.isArray(order) && order.length === days.length && new Set(order).size === order.length && order.every(n => ids.has(n));
};
export const applyDayOrder = (days, order) => {
  if (!validateOrder(days, order)) throw new Error('Choose a complete shooting-day order without missing or repeated days.');
  const byNumber = new Map(days.map(d => [d.dayNumber, d]));
  const slots = dateSlots(days);
  return order.map((n, i) => ({ ...byNumber.get(n), ...slots[i], dayNumber: i + 1 }));
};
export const moveDayOrder = (days, from, to) => {
  const order = orderedDays(days).map(d => d.dayNumber);
  const index = order.indexOf(from);
  if (index < 0 || !Number.isInteger(to) || to < 1 || to > days.length) throw new Error('Choose an existing shooting day and destination position.');
  order.splice(to - 1, 0, ...order.splice(index, 1));
  return order;
};
export const moveWholeDay = (days, from, to) => applyDayOrder(days, moveDayOrder(days, from, to));